import { Component, OnInit } from "@angular/core";
import { BaseComponent, AnnouncementService, PusherService, Shared, UserService } from "@rubii/frontend-common";
import { WsEvent } from "@rubii/frontend-common/lib/models/events/ws-event.class";
import { NotificationChannels } from "@rubii/sdk-web-notification/src/types";

@Component({
    selector: "app-maintenance",
    templateUrl: "./maintenance.component.html",
    styleUrls: ["./maintenance.component.scss"],
})
export class MaintenanceComponent extends BaseComponent implements OnInit {
    maintenanceMsg = '';
    maintenanceMsgSub;
    constructor(
        private pusher: PusherService,
        private announcementService: AnnouncementService,
        private user: UserService,) {
        super();
       

    }

    ngOnInit() {
        const tenantId = this.user.user?.tenant?.id;
        console.log(`subscribing tenant announcement finished events for ${tenantId}`)
        const tenantAnnChannel = NotificationChannels.TenantAnnouncementChannel(tenantId);
        this.pusher.bind(tenantAnnChannel, Shared.dicts.PushChannels.maintenance.events.finished, this.maintenanceUpdated.bind(this));

        console.log(`subscribing global announcement finished events for ${tenantId}`)
        const channel = NotificationChannels.GlobalAnnouncementChannel;
        this.pusher.bind(channel, Shared.dicts.PushChannels.maintenance.events.finished, this.maintenanceUpdated.bind(this));

        this.maintenanceMsgSub = this.announcementService.pageInfo.subscribe(updatedData => {
            this.maintenanceMsg = updatedData;
        });
        this.announcementService.getCurrentMaintenance();
    }
    ngOnDestroy() {
        this.maintenanceMsgSub?.unsubscribe();
    }

    maintenanceUpdated(event: WsEvent) {
        const message = event.data;
        const activeMaintenanceId = this.announcementService.annId;
        if (this.user.user.id && message._id == activeMaintenanceId) {
            window.location.href = this.user.getTrackerUrl();
        }
    }
}